import {TeamAssignmentStateActions as actions} from '../../const/actionType';

export const setDate = (date) => ({
  type: actions.SET_DATE,
  date,
});

export const setAvailableEmployee = (availableEmployee) => ({
  type: actions.SET_AVAILABLE_EMPLOYEE,
  availableEmployee,
});

export const setAssignedEmployee = (assignedEmployee) => ({
  type: actions.SET_ASSIGNED_EMPLOYEE,
  assignedEmployee,
});

export const setEmployeeIdToRoleChange = (employeeIdToRoleChange) => ({
  type: actions.SET_EMPLOYEE_ID_TO_ROLE_CHANGE,
  employeeIdToRoleChange,
});

export const setEmployeeIdToAssign = (employeeIdToAssign) => ({
  type: actions.SET_EMPLOYEE_ID_TO_ASSIGN,
  employeeIdToAssign,
});

export const setProjects = (projects) => ({
  type: actions.SET_PROJECTS,
  projects,
});

export const setSelectedProject = (selectedProject) => ({
  type: actions.SET_SELECTED_PROJECT,
  selectedProject,
});


export const setTeamProject = (teamProject) => ({
  type: actions.SET_TEAM_PROJECT,
  teamProject,
});

export const setShowModalTeam = (showModalTeam) => ({
  type: actions.SET_SHOW_MODAL_TEAM,
  showModalTeam,
});

export const setShowModalDatePicker = (showModalDatePicker) => ({
  type: actions.SET_SHOW_MODAL_DATE_PICKER,
  showModalDatePicker,
});

export const setHistoryData = (historyData) => ({
  type: actions.SET_HISTORY_DATA,
  historyData,
});

export const setHistoryLoading = (isLoading) => ({
  type: actions.SET_HISTORY_LOADING,
  isLoading,
});

export const setTeamAssignmentLoading = (isLoading) => ({
  type: actions.SET_TEAM_ASSIGNMENT_LOADING,
  isLoading,
});

export const setAllDepartments = (allDepartments) => ({
  type: actions.SET_ALL_DEPARTMENTS,
  allDepartments,
});

export const setPeriods = (periods) => ({
  type: actions.SET_PERIODS,
  periods
});

export const setSaveAssignButton = (saveAssignButton) => ({
  type: actions.SET_SAVE_ASSIGN_BUTTON,
  saveAssignButton
});

export const setSelectedPeriod = (selectedPeriod) => ({
  type: actions.SET_SELECTED_PERIOD,
  selectedPeriod,
});

export const resetStateTeamAssignment = () => ({
  type: actions.RESET_STATE_TEAM_ASSIGNMENT,
});

export const setEmployeeIdToRemove = (employeeIdToRemove) => ({
  type: actions.SET_EMPLOYEE_ID_TO_REMOVE,
  employeeIdToRemove,
});

export default actions;